// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
} from '@mui/material'
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import moment from 'moment'
import DialogSaldoAwalPiutang from '../../../components/acc/DialogSaldoAwalPiutang'
import DialogSaldoAwalHutang from '../../../components/acc/DialogSaldoAwalHutang'
import DialogSaldoAwalBarang from '../../../components/acc/DialogSaldoAwalBarang'
import DialogSaldoAwalAkun from '../../../components/acc/DialogSaldoAwalAkun'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")
    const [listData, setListData] = useState<any[]>([])
    const [openDialogSaldoAwalPiutang, setOpenDialogSaldoAwalPiutang] = useState<boolean>(false)
    const [openDialogSaldoAwalHutang, setOpenDialogSaldoAwalHutang] = useState<boolean>(false)
    const [openDialogSaldoAwalBarang, setOpenDialogSaldoAwalBarang] = useState<boolean>(false)
    const [openDialogSaldoAwalAkun, setOpenDialogSaldoAwalAkun] = useState<boolean>(false)

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))
    useEffect(() => {
        getData(tabs)
    }, [])

    const getData = (mode: any) => {
        setListData([])
        let url = apiUrl.apiUrl + '/acc/saldo-awal/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/acc/saldo-awal/delete/' + row.id
        axios.post(url, {
            mode : tabs
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                if (response.data.success) {
                    getData(tabs)
                    showToast("Data berhasil dihapus", "success")
                } else {
                    showToast(response.data.message, "error")
                }
            })
            .catch(error => {
                showToast(error.message, "error")
            })
    };
    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip key={"Hapus"} title={"Hapus"} placement="top">
                    <IconButton onClick={() => onDelete(row)}>
                        <Icon icon={"mdi:trash"} color={"red"} />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 70,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];
    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='SALDO AWAL' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            container
                            spacing={3}
                            alignItems="flex-end"
                        >
                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label="Tanggal Awal"
                                    type="date"
                                    value={tglAwal}
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    fullWidth
                                    label="Tanggal Akhir"
                                    type="date"
                                    value={tglAkhir}
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={<Icon icon="mdi:magnify" />}
                                    onClick={() => getData(tabs)}
                                    sx={{ height: 56 }}
                                >
                                    Cari Data
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Piutang' />
                            <Tab value='1' label='Hutang' />
                            <Tab value='2' label='Barang' />
                            <Tab value='3' label='Akun' />
                        </TabList>
                        <TabPanel value='0'>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    setOpenDialogSaldoAwalPiutang(true)
                                }}
                                sx={{ mr: 1 }}
                            >
                                TAMBAH SALDO AWAL PIUTANG
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    setOpenDialogSaldoAwalHutang(true)
                                }}
                                sx={{ mr: 1 }}
                            >
                                TAMBAH SALDO AWAL HUTANG
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    setOpenDialogSaldoAwalBarang(true)
                                }}
                            >
                                TAMBAH SALDO AWAL BARANG
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total','harga']} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='3'>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:add" />}
                                onClick={() => {
                                    setOpenDialogSaldoAwalAkun(true)
                                }}
                                sx={{ mr: 1 }}
                            >
                                TAMBAH SALDO AWAL AKUN
                            </Button>
                            <MsiDatagrid array={listData} convertNumeric={['total']} actions={actionData} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
            <DialogSaldoAwalPiutang
                key={"dialog-saldo-awal-piutang"}
                open={openDialogSaldoAwalPiutang}
                onClose={() => {
                    setOpenDialogSaldoAwalPiutang(false)
                    getData(tabs)
                }}
            />
            <DialogSaldoAwalHutang
                key={"dialog-saldo-awal-hutang"}
                open={openDialogSaldoAwalHutang}
                onClose={() => {
                    setOpenDialogSaldoAwalHutang(false)
                    getData(tabs)
                }}
            />
            <DialogSaldoAwalBarang
                key={"dialog-saldo-awal-barang"}
                open={openDialogSaldoAwalBarang}
                onClose={() => {
                    setOpenDialogSaldoAwalBarang(false)
                    getData(tabs)
                }}
            />
            <DialogSaldoAwalAkun
                key={"dialog-saldo-awal-akun"}
                open={openDialogSaldoAwalAkun}
                onClose={() => {
                    setOpenDialogSaldoAwalAkun(false)
                    getData(tabs)
                }}
            />
        </Grid>
    )
}
